// extracted by mini-css-extract-plugin
export default {"priorityItem":"PriorityItem_priorityItem__9vQsz"};